import React from 'react';
import { AzureMP } from 'react-azure-mp'
import Button from '@material-ui/core/Button';
import { Upload, Icon } from 'antd';
import AzureServices from '../../services/AzureServices';

export default class CommunicationViewerScreen extends React.Component {
    state = {
        fileList: [],
        uploading: false,
        finishedOrError: false
    };
    blobUri = 'https://' + this.state.accountName + '.blob.core.windows.net';
    azureStorage = require('azure-storage');

    createContainer = async (file) => {
        const containerName = 'newexampleimage';
            await AzureServices.connection(containerName,'blob', file)
    }
            
    handleUpload = () => {
        const { fileList } = this.state;
        const formData = new FormData();
        fileList.forEach(file => {
          formData.append('files[]', file);
        });
        this.createContainer(this.state.fileList);
    };
  
    render() {
        const { uploading, fileList } = this.state;
        const props = {
          onRemove: file => {
            this.setState(state => {
                const index = state.fileList.indexOf(file);
              const newFileList = state.fileList.slice();
              newFileList.splice(index, 1);
              return {
                fileList: newFileList,
            };
            });
          },
          beforeUpload: file => {
              this.setState(state => ({
              fileList: [...state.fileList, file],
            }));
            return false;
          },
          fileList,
        };
      return (
        <div>
        <AzureMP
            skin="amp-flush"
            src={[{
                src: "//amssamples.streaming.mediaservices.windows.net/3b970ae0-39d5-44bd-b3a3-3136143d6435/AzureMediaServicesPromo.ism/manifest", type: "application/vnd.ms-sstr+xml" }]}
        />
        <Upload {...props}>
            <Button>
                <Icon type="upload" /> Select File
            </Button>
        </Upload>
        <Button
            type="submit"
            onClick={this.handleUpload}
            disabled={fileList.length === 0}
            loading={uploading}
            style={{ marginTop: 16 }}
        >
        {uploading ? 'Uploading' : 'Start Upload'}
        </Button>
    </div>
      );
    }
}
